<script>
    import Icon from '../../components/Icon.svelte';
    import sessionStore from 'store/session';
    import pubsub from 'sweet-pubsub';
    import { useNavigate } from 'svelte-navigator';
    import Chat from '../../services/chat/chat.js';
    import { StreamChatProvider } from '../../services/chat/providers';
    import { useFocus } from "svelte-navigator";
  
    const registerFocus = useFocus();
    const navigate = useNavigate()
    const chat = new Chat(new StreamChatProvider())
    let channels = [];
    let initChannels = [];
    let loadingChannel = true;
    setTimeout(() => {
        chat.channels().then(res => {
            channels = res
            initChannels = res
        }).finally(() => {
            loadingChannel = false;
        })
    }, 500);

    let search_text = '';

    $: channels = initChannels.filter((channel) => {
        // we'll convert the search text to lowercase
        const search = search_text.toLowerCase();
        // and then we'll check if the channel name or number contains the search text
        return (
            channel.data.created_by.name.toLowerCase().includes(search)
        );
    });

    const getInitials = (name) => {
        const words = name.split(' ').slice(0, 2);
        const initials = words.map((word) => word[0]);
        return initials.join('');
    };

</script>

<div id="contact-list">
    <div class="row">
        <div class="contact-list-panel">
            <div class="search-box">
                <div class="icon search"><Icon icon="search" /></div>
                <input
                    type="text"
                    placeholder="search users"
                    bind:value={search_text}
                    use:registerFocus
                />
            </div>
            <ul class="contact-list">
                {#each channels as channel (channel.id)}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <li on:click={navigate(`/chat/${channel.id}`)}>
                        <div class="icon mr-10 greenicon">
                            {getInitials(channel.data.created_by.name)}
                        </div>
                        <div class="d-flex contact-detail">
                            <p class="font-700 m-0">{channel.data.created_by.name}</p>
                            <!-- svelte-ignore a11y-invalid-attribute -->
                            <a href="#" class={channel.state.unreadCount > 0 ? 'has-message' : 'has-no-message'}>
                                { channel.id } | messages ({channel.state.unreadCount}/{channel.state.latestMessages.length})
                            </a>
                        </div>
                    </li>
                {/each}
            </ul>
            <span class={`${loadingChannel ? "loader": ""}`}></span>
        </div>
    </div>
    <div class="menu">
        <div class="row bottom-nav d-flex">
            <a
                href="#"
                class="w-25"
                on:click={() => navigate('/')}
            >
                <Icon icon="slack" color='#0E99D2' />
                <span style="color: #0E99D2;"> Dial Pad</span>
            </a>
        </div>
    </div>
</div>

<style lang="scss">
    #contact-list {
        .contact-list-panel {
            padding: 0 0.75rem !important;
            max-height: 392px;
            margin-top: 1rem;
            overflow-y: scroll;
            .search-box {
                position: relative;
                .icon.search {
                    position: absolute;
                    top: 12px;
                    left: 15px;
                }
                input {
                    border: 1px solid #eeeeee;
                    border-radius: 4px;
                    padding: 12px 16px;
                    padding-left: 40px;
                    box-sizing: border-box;
                    width: 100%;
                    font-weight: 400;
                    font-size: 16px;
                    color: black;
                }
            }
            .contact-list {
                padding: 0;
                list-style: none;
                li {
                    // overflow-y: scroll;
                    border-bottom: 1px solid rgba(17, 54, 69, 0.05);
                    padding-bottom: 16px !important;
                    margin-bottom: 16px !important;
                    border-radius: 0px !important;
                    width: 100% !important;
                    display: flex;
                    cursor: pointer;
                    .icon {
                        padding: 10px;
                        background-color: #1a96f0;
                        color: #fff;
                        width: 40px;
                        height: 40px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 21px;
                        font-weight: 700;
                    }
                    .pinkicon {
                        background-color: #ea1e61 !important;
                    }
                    .greenicon {
                        background-color: #009689 !important;
                    }
                    .purpleicon {
                        background-color: #3f51b2 !important;
                    }
                    .contact-detail {
                        flex-direction: column;
                    }
                    p {
                        line-height: 1.3;
                    }
                    a {
                        font-size: 12px;
                        &.has-message {
                            color: #3daddb !important;
                        }
                        &.has-no-message {
                            color: #36505b !important;
                        }
                    }
                }
            }
        }
        .contact-list-panel::-webkit-scrollbar {
            display: none;
        }
        .menu {
            position: absolute;
            bottom: 0;
            padding: 0 10px;
            .bottom-nav {
                background-color: #fafdff;
                justify-content: space-evenly;
                padding: 10px;
                a {
                    color: #a7b4be;
                    font-size: 12px;
                    margin-top: 5px;
                    font-weight: 500;
                }
                a.active {
                    color: #0e99d2;
                    font-weight: 700;
                }
                .w-25 {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 5px;
                }
            }
        }
    }
</style>
